<template>
	<h2 class="order-block-title">
		<strong v-if="props.prefix" class="prefix" v-text="props.prefix"></strong>
		<span class="title" v-text="props.title"></span>
	</h2>
</template>

<script lang="ts" setup>
	import type {OrderBlock} from '@/types/orderblock';

	const props = defineProps<{
		title: OrderBlock['title'],
		prefix: OrderBlock['titlePrefix']
	}>();
</script>

<style lang="scss" scoped>
	h2 {
		display: flex;
		flex-wrap: nowrap;
		align-items: flex-start;
		justify-items: flex-start;
		color: var(--color-primary_blue, #008ecf);
		font-weight: bold;
	}

	.title {
		flex: 0 1 auto;
		align-self: center;
		padding-top: .2em;
		word-break: break-word;
		hyphens: auto;

		&:first-child {
			padding-top: .2em;
		}
	}

	.prefix {
		flex: 0 0 auto;
		background: var(--color-secondary-pink, #e53171);
		color: var(--color-grey_00, #ffffff);
		border-radius: 50%;
		font-size: smaller;
		height: 2em;
		width: 2em;
		margin: 0 1.2em 0 0;
		padding: .2em 0 0;
		font-weight: bold;
		line-height: 1.5;
		display: inline-flex;
		align-items: center;
		justify-content: center;
	}
</style>
